export default __webpack_public_path__ + "static/media/iread_22_1.1e0bdefa.jpg";